import { createTheme } from '@material-ui/core';
declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    sidebarWidth: number;
    sidebarMobileHeight: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
    rightDrawerWidth: number;
    galleryViewBackgroundColor: string;
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    sidebarWidth?: number;
    sidebarMobileHeight?: number;
    brand: string;
    footerHeight: number;
    mobileTopBarHeight: number;
    mobileFooterHeight: number;
    sidebarMobilePadding: number;
    participantBorderWidth: number;
    rightDrawerWidth?: number;
    galleryViewBackgroundColor: string;
  }
}

const defaultTheme = createTheme();

export default createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [
          {
            fontDisplay: 'swap',
            fontFamily: 'Roboto',
            fontWeight: '100 400',
            src: `url(https://designsystem.sendinblue.com/designsystem/4df07f345ca93db95ad4.woff2) format("woff2"), url(https://designsystem.sendinblue.com/designsystem/b21f999eb3da2c189cb6.woff) format("woff")`,
          },
          {
            fontDisplay: 'swap',
            fontFamily: 'Roboto',
            fontWeight: '500 600',
            src: `url(https://designsystem.sendinblue.com/designsystem/50b0ab5e591fc75a34c7.woff2) format("woff2"), url(https://designsystem.sendinblue.com/designsystem/39806803b69e0c4dc1df.woff) format("woff")`,
          },
          {
            fontDisplay: 'swap',
            fontFamily: 'Roboto',
            fontWeight: '700 900',
            src: `url(https://designsystem.sendinblue.com/designsystem/620aa4a89efb0516fd59.woff2) format("woff2"), url(https://designsystem.sendinblue.com/designsystem/f6f9ba7dd71c70a7f20f.woff) format("woff")`,
          },
        ],
        'html, body, #root': {
          height: '100%',
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: '5px',
        textTransform: 'none',
        color: 'rgb(40, 42, 43)',
        fontSize: '1rem',
        transition: defaultTheme.transitions.create(['background-color', 'box-shadow', 'border', 'color'], {
          duration: defaultTheme.transitions.duration.short,
        }),
      },
      text: {
        padding: '6px 14px',
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
        },
      },
      outlinedPrimary: {
        border: '2px solid #000',
        '&:hover': {
          border: '2px solid #000',
        },
      },
      startIcon: {
        marginRight: '6px',
      },
    },
    MuiTypography: {
      body1: {
        color: 'rgb(40, 42, 43)',
        fontSize: '0.9rem',
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '0.9rem',
      },
    },
    MuiSelect: {
      root: {
        padding: '0.85em',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '16px',
      },
    },
    MuiTextField: {
      root: {
        color: 'rgb(40, 42, 43)',
      },
    },
    MuiInputLabel: {
      root: {
        color: 'rgb(40, 42, 43)',
        fontSize: '1.1rem',
        marginBottom: '0.2em',
        fontWeight: 500,
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: 'rgb(136, 140, 142)',
      },
    },
  },
  typography: {
    fontFamily: 'Roboto,Helvetica Neue,sans-serif',
  },
  palette: {
    primary: {
      main: '#000',
    },
  },
  brand: '#00c6ff',
  footerHeight: 72,
  mobileFooterHeight: 56,
  sidebarWidth: 300,
  sidebarMobileHeight: 90,
  sidebarMobilePadding: 8,
  participantBorderWidth: 2,
  mobileTopBarHeight: 52,
  rightDrawerWidth: 400,
  galleryViewBackgroundColor: 'var(--sib-color_content-primary)',
});
